module.exports = __webpack_public_path__ + "img/checkmark_dark.1ba83612.svg";